import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=6543cfc4&scoped=true"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=6543cfc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6543cfc4",
  null
  
)

export default component.exports